import { Navigation } from './Navigation';
export class ConfirmAssistance extends Navigation 
{
    public firstName:string;
	public lastName:string;
	public organizationName: string;
	public addressLine1:string;
	public addressLine2:string;
	public city:string;
	public state:string;
	public zipCode:string;
	public organizationWebsite:string;
	public userEmail:string;
	public phoneNumber:string;
}